import script from "./editModal.vue?vue&type=script&setup=true&lang=js"
export * from "./editModal.vue?vue&type=script&setup=true&lang=js"

import "./editModal.vue?vue&type=style&index=0&id=628b5888&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-628b5888"]])

export default __exports__